import config from '@plone/volto/registry';
export const CirclesItemSchema = (props) => {
  return {
    title: 'Item',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'title',
          'pill_hexcolor',
          'description',
          'image',
          'image_alt',
          'text_link',
          'link',
          'description_link',
          'openInNewTab',
        ],
      },
    ],
    properties: {
      title: {
        title: 'Title',
        widget: 'text',
      },
      pill_hexcolor: {
        title: 'Pill color',
        description: 'Hexadecimal color code. By default: #644380',
        type: 'color',
        widget: 'style_simple_color',
        available_colors: config.settings.dark_colors,
      },
      description: {
        title: 'Description',
        widget: 'richtext',
      },
      image: {
        title: 'Image',
        description: 'This block is designed to insert a vertical image',
        widget: 'object_browser',
        mode: 'image',
        allowExternals: true,
        selectedItemAttrs: ['image_field', 'image_scales'],
        allowedContentTypes: ['Image'],
      },
      image_alt: {
        title: 'Image alt',
      },
      text_link: {
        title: 'Text link',
        widget: 'text',
      },
      link: {
        title: 'Link URL',
        widget: 'object_browser',
        mode: 'link',
        allowExternals: true,
      },
      description_link: {
        title: 'Description link',
        widget: 'text',
      },
      openInNewTab: {
        title: 'Open link in new tab',
        type: 'boolean',
      },
    },
    required: ['title', 'description', 'image'],
  };
};

export const CirclesSchema = (props) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'description', 'items'],
      },
    ],
    properties: {
      title: {
        title: 'Title',
        widget: 'text',
      },
      description: {
        title: 'Description',
        widget: 'richtext',
      },
      items: {
        title: 'Items',
        widget: 'object_list',
        schema: CirclesItemSchema(props),
        activeObject: props.activeObject,
        setActiveObject: props.setActiveObject,
      },
    },
    required: ['title', 'description'],
  };
};

export default CirclesSchema;
